import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import PrintIcon from '@material-ui/icons/Print';
import { Values } from '../../../../values/Values';
import Alert from '@material-ui/lab/Alert';


const useStyles = makeStyles(theme => ({
  gridBotaoDelete: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  gridBotaoSalvar: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  gridBotaoDownload: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  botaoDelete: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.white
  }
}));

const FiliadoToolbar = props => {
  const { className, history, saveFiliado, filiado, registrarNovaVisita, ...rest } = props;
  const { downloadPDF } = props;
  const { edicao } = props;
  const [ abrirDialogImpressaoVisitas, setAbrirDialogImpressaoVisitas ] = useState(false);
  const classes = useStyles();


  const cancelarInsercao = () => {
    history.goBack();
  };

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={3}
        xs={12}
        className={classes.gridBotaoDelete}
      >
        <Button
          variant="contained"
          onClick={cancelarInsercao}
          fullWidth
          startIcon={<CancelIcon/>}
          className={classes.botaoDelete}
        >
          Cancelar
        </Button>
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
        className={classes.gridBotaoDownload}
      >
        {edicao &&
          <Button
            color="primary"
            variant="outlined"
            onClick={downloadPDF}
            fullWidth
            startIcon={<PrintIcon/>}
          >
            Download ficha
          </Button>
        }
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
        className={classes.gridBotaoDownload}
      >
        {edicao &&
        <Button
          color="primary"
          variant="outlined"
          onClick={e => registrarNovaVisita(e)}
          fullWidth
          startIcon={<EventAvailableIcon/>}
        >
          Registrar nova visita
        </Button>
        }
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
        className={classes.gridBotaoSalvar}
      >
        <Button
          color="primary"
          variant="contained"
          type={'submit'}
          fullWidth
          startIcon={<CheckCircleOutlineIcon/>}
        >
          Salvar
        </Button>
      </Grid>
      {
        filiado?.idFiliacaoStatus === Values.FiliacaoStatusValues.inadimplente &&
        <Grid
          item
          md={12}
          xs={12}
        >
          <Alert severity="error">ATENÇÃO - Filiado inadimplente. Necessário atenção.</Alert>
        </Grid>
      }
    </Grid>
  );
};

FiliadoToolbar.propTypes = {
  className: PropTypes.string
};

export default FiliadoToolbar;
